const ResourcePage = ({ title, breadcrumb = [], actions, children }) => {
  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box app-page-title">
            <div>
              <h4 className="page-title">{title}</h4>
              <ol className="breadcrumb m-0">
                {breadcrumb.map((item, index) => (
                  <li className={`breadcrumb-item ${index === breadcrumb.length - 1 ? "active" : ""}`} key={item}>
                    {item}
                  </li>
                ))}
              </ol>
            </div>
            {actions && <div className="app-page-actions">{actions}</div>}
          </div>
        </div>
      </div>

      {children}
    </>
  );
};

export default ResourcePage;
